/**
 * @generated SignedSource<<9b473f2959a6097a7305159460271aae>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "model"
        }
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "model",
                    "variableName": "model"
                }
            ],
            "concreteType": "UpdateSchedulePayload",
            "kind": "LinkedField",
            "name": "updateSchedule",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "EdgeOfSchedule",
                    "kind": "LinkedField",
                    "name": "scheduleEdge",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Schedule",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "id",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "name",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "EditScheduleModalGeneralTab_updateScheduleMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "EditScheduleModalGeneralTab_updateScheduleMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "dfd5c6eb9726883ce2cc78b3abb3d302",
            "id": null,
            "metadata": {},
            "name": "EditScheduleModalGeneralTab_updateScheduleMutation",
            "operationKind": "mutation",
            "text": "mutation EditScheduleModalGeneralTab_updateScheduleMutation(\n  $model: UpdateScheduleRequestInput!\n) {\n  updateSchedule(model: $model) {\n    scheduleEdge {\n      node {\n        id\n        name\n      }\n    }\n  }\n}\n"
        }
    };
})();
node.hash = "85814a0fbc1c902bff121eb73b8868bb";
export default node;
